import {Container, ContentLayout, Header} from "@cloudscape-design/components";

const NoMatch = () => {
    return (
        <ContentLayout
            header={
                <Header variant="h1">
                    Error
                </Header>
            }
        >
            <Container>
                <div className="contentPlaceholder" >
                    That page could not be found
                </div>
            </Container>
        </ContentLayout>
    );
}
export default NoMatch;
